/* unplugin-vue-components disabled */import script from "./Loading.vue?vue&type=script&setup=true&lang=js"
export * from "./Loading.vue?vue&type=script&setup=true&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=1a3a48b8&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\www.changshun.com\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3a48b8"]])

export default __exports__